import { render, staticRenderFns } from "./NavFilters.vue?vue&type=template&id=3cd60b67&scoped=true&"
import script from "./NavFilters.vue?vue&type=script&lang=js&"
export * from "./NavFilters.vue?vue&type=script&lang=js&"
import style0 from "./NavFilters.vue?vue&type=style&index=0&id=3cd60b67&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd60b67",
  null
  
)

export default component.exports